import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useBlogs } from "@/lib/queries";
import SectionHeading from "@/components/SectionHeading";
import { Reveal } from "@/components/Reveal";

export default function BlogSection() {
  const { data } = useBlogs();
  const items = data?.items || [];
  if (!items.length) return null;

  return (
    <section data-testid="blog-section" className="obsidian border-t border-white/10 py-24 sm:py-32">
      <div className="container-x">
        <div className="flex flex-col items-start justify-between gap-8 sm:flex-row sm:items-end">
          <SectionHeading
            number="05"
            overline="Araç Bakım Rehberi"
            title="Kocaeli Araç Bakım Rehberi"
            subtitle="Boyanızı ve aracınızı korumak için bilmeniz gerekenler, uzman ağzından."
          />
          <Link
            to="/blog"
            className="group hidden shrink-0 items-center gap-2 border border-white/15 px-6 py-3.5 font-oswald text-xs uppercase tracking-[0.2em] text-white transition-colors hover:border-gold/50 hover:text-gold sm:inline-flex"
          >
            Tüm Yazılar <ArrowUpRight className="h-4 w-4 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
          </Link>
        </div>

        <div className="mt-14 grid gap-3 md:grid-cols-3">
          {items.slice(0, 3).map((b, i) => (
            <Reveal key={b.slug} delay={i * 0.08}>
              <Link
                to={`/blog/${b.slug}`}
                data-testid={`blog-card-${b.slug}`}
                className="group flex h-full flex-col overflow-hidden border border-white/10 bg-neutral-900 transition-colors hover:border-gold/40"
              >
                <div className="relative aspect-[16/10] overflow-hidden">
                  <img src={`${b.cover_image}?w=640`} alt={b.title} loading="lazy" decoding="async" className="h-full w-full object-cover grayscale-[0.2] transition-all duration-700 group-hover:scale-105 group-hover:grayscale-0" />
                  <span className="absolute left-4 top-4 font-oswald text-sm font-bold tracking-[0.2em] text-white/50">{String(i + 1).padStart(2, "0")}</span>
                </div>
                <div className="flex flex-1 flex-col p-6">
                  <h3 className="font-display text-lg font-medium leading-snug text-white transition-colors group-hover:text-gold">{b.title}</h3>
                  <p className="mt-2 flex-1 text-sm text-neutral-400 line-clamp-3">{b.excerpt}</p>
                  <span className="mt-5 inline-flex items-center gap-1.5 font-oswald text-xs uppercase tracking-[0.15em] text-gold">Devamını Oku <ArrowUpRight className="h-3.5 w-3.5" /></span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
